import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getTopClients} from "../../store/reducers/ClientsSlice";
import RangeSearch from "./components/RangeSearch";
import {getStatuses} from "../../store/reducers/ResultsSlice";
import {Link} from "react-router-dom";

interface StatusResultsScreenProps {
}

export const StatusResultsScreen: React.FC<StatusResultsScreenProps> = () => {

    const dispatch = useAppDispatch();

    const resultsState = useAppSelector(state => state.results);

    useEffect(() => {
        dispatch(getStatuses());
    }, []);

    const formatTime = (seconds: number): string => {
        const days = Math.floor(seconds / (60 * 60 * 24));
        const hours = Math.floor((seconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((seconds % (60 * 60)) / 60);
        const remainingSeconds = seconds % 60;

        return `${days} päev${days !== 1 ? 'a' : ''}, ${hours} tund${hours !== 1 ? 'i' : ''}, ${minutes} minut${minutes !== 1 ? 'it' : ''}, ${remainingSeconds} sekund${remainingSeconds !== 1 ? 'it' : ''}`;
    };

    return (
        <LoggedInView fullWidth={false}>
            <h1>Jaotusest väljasoleku ülevaade</h1>
            <RangeSearch url={'results/status'} userVisible={false}/>
            <table className="data">
                <thead>
                <tr>
                    <th className="left" style={{width: '200px'}}>Nimi</th>
                    <th className="left"></th>
                </tr>
                </thead>
                <tbody>
                {resultsState.statuses.map(user => (
                    <tr key={'user' + user.id}>
                        <td><Link to={'/results/status/' + user.id}>{user.firstName}</Link></td>
                        <td>{formatTime(user.timeOffline)}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </LoggedInView>
    )

}